import(/* webpackMode: "eager" */ "/vercel/path0/app/(feed)/layout.tsx");
